import {Component} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'loading-dialog',
    templateUrl: 'loading.dialog.html',
})
export class LoadingDialog {
    constructor(public translate: TranslateService){}
}
